<template>
  <div class="container-reports">
    <div class="table-option column mb-2 col-md-12 justify-content-left p-0">
      <b-modal
        centered
        ref="dialogWait"
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
        hide-header
        hide-footer
      >
        <div class="center-xs">
          <spinner />
        </div>
        <div class="center-xs pt-3">
          {{ currentLoadingMessage }}
        </div>
      </b-modal>

      <div class="w-100 row justify-content-end align-items-center">
        <b-button
          @click="$refs.dataTable ? $refs.dataTable.importJSON() : ''"
          size="sm"
          variant="outline-secondary"
          class="m-1 mb-1 font-weight-regular"
        >
          <upload-icon style="font-size: 1.1em; vertical-align: -3%" />
          Importar Configuração
        </b-button>
        <b-button
          class="align-items-center font-weight-regular"
          :class="showDownloadOptions ? null : 'collapsed'"
          size="sm"
          id="downloads-options"
          variant="outline-secondary"
          :aria-expanded="showDownloadOptions ? 'true' : 'false'"
          aria-controls="collapse-downloads"
          @click="showDownloadOptions = !showDownloadOptions"
        >
          Baixar Planilha
        </b-button>
      </div>
      <b-collapse
        id="collapse-downloads"
        v-model="showDownloadOptions"
        class="mt-1 download-options"
      >
        <download-table-content
          :downloadCSV="$refs.dataTable ? $refs.dataTable.downloadCSV : ''"
          :downloadXLSX="$refs.dataTable ? $refs.dataTable.downloadXLSX : ''"
          :downloadPDF="$refs.dataTable ? $refs.dataTable.downloadPDF : ''"
          :downloadJSON="$refs.dataTable ? $refs.dataTable.downloadJSON : ''"
          class="py-2 py-lg-2"
        />
      </b-collapse>

      <div class="w-100">
        <b-button
          rounded
          size="sm"
          variant="secondary"
          class="m-1 align-items-center"
          @click="addRowDap"
          :class="{ disabled: hasUncompletedRow }"
        >
          Adicionar faixa
        </b-button>
        <b-button
          @click="deleteRowBtn"
          rounded
          size="sm"
          variant="secondary"
          class="m-1 align-items-center"
          :class="{ disabled: !itemsSelected.length }"
        >
          Deletar faixa
        </b-button>

        <b-button
          @click="itemsSelected.length ? replyRows() : ''"
          rounded
          size="sm"
          variant="secondary"
          class="m-1 align-items-center"
          :class="{ disabled: !itemsSelected.length || hasUncompletedRow }"
        >
          Clonar linha(s)
        </b-button>

        <b-button
          @click.prevent="saveTable"
          rounded
          size="sm"
          :variant="changedTableData ? 'success' : ''"
          :disabled="!changedTableData"
          class="m-1 align-items-center"
        >
          Salvar
        </b-button>

        <p class="last-update-farm">
          Última modificação {{ lastUpdate }} por {{ editorName }}
        </p>
      </div>
    </div>
    <!-- max-height-table="58vh" -->
    <data-table
      ref="dataTable"
      editable
      selectable
      move-rows
      sticky-header
      max-height-table="58vh"
      :left-frozen-columns="leftFrozenColumns"
      :static-columns="staticColumns"
      :table-data="tableData"
      :file-prefix="title"
      @update-selected-items="updateSelectedItems"
      @update-table-data="updateTableData"
      :is-reactive="true"
    />
    <!-- @add-new-row="addRowDap()" -->
    <b-modal
      ref="farmsHasSectorModal"
      centered
      size="sm"
      ok-title="Salvar"
      cancel-title="Cancelar"
      ok-variant="danger"
      @ok="submit"
      @cancel="closeItemsWithSectorsModal"
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          Caso seja realizado alguma alteração nos dados de DAP do cultivar, ao
          salvar será necessário editar os setores que possuem esse cultivar
          para que seja reacalculado os dados de manejo.
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="notSaveEmptyFarmModal"
      centered
      size="sm"
      ok-title="Estou ciente"
      ok-variant="danger"
      @ok="closeEmptyFarmModal"
      ok-only
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          Antes de apagar os dados, será necessário primeiro desvincular esse
          cultivar dos setores.
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { showFarmsDapByIdFarmUseCase } from "../../../../api/modules/farms_dap/useCases/showFarmsDapByIdFarm";
import { checkIfFarmHasSector } from "../../../../api/modules/farms_dap/useCases/checkIfHasSector";
import DataTable from "../../../components/shared/table/DataTable.vue";
import DownloadTableContent from "../../../components/shared/table/DownloadTableContent.vue";
import table from "@/mixins/table";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import { management } from "@/api";
import { cookies } from "../../../components/cookies";

export default {
  name: "SpreadSheet",
  mixins: [table, managementSectorsActions],
  props: {
    idFarm: {
      required: true,
      type: Number,
    },
    editorName: {
      type: [String, Boolean],
      required: true,
      default: () => "---",
    },
    lastUpdate: {
      type: String,
      required: true,
      default: () => "xx/xx/xxxx",
    },
    title: {
      required: false,
      type: String,
      default: function (props) {
        return `Cultivar ${props.idFarm}`;
      },
    },
  },
  components: {
    DataTable,
    DownloadTableContent,
  },
  created() {
    // console.log("created farms");
    // debugger
  },
  data() {
    return {
      loading: false,
      currentLoadingMessage: "",
      showDownloadOptions: false,
      itemsSelected: [],
      fertilizersList: [
        { id: 0, fertilizer_name: "ADUBO1", isSpecial: false },
        { id: 1, fertilizer_name: "ADUBO2", isSpecial: false },
        { id: 2, fertilizer_name: "ADUBO3", isSpecial: true },
        { id: 3, fertilizer_name: "ADUBO4", isSpecial: false },
      ],
      tableData: [], //data for table to display
      tableDataUnchanged: [], //data for table to display
      // qtdFertilizerCols: 6,
      // Início: derivado/não-editável. Fim: editável. Banco segue 1 linha/dia (expand no save).
      leftFrozenColumns: [
        {
          title: "Início",
          field: "INICIO",
          sorter: "number",
          minWidth: 80,
          width: 80,
          headerSort: false,
          accessorDownload: (val) => val,
        },
        {
          title: "Fim",
          field: "FIM",
          editable: true,
          editor: "input",
          sorter: "number",
          minWidth: 80,
          width: 80,
          headerSort: false,
          validator: (cell, value) => {
            if (value === "" || value === null) return true;
            const n = Number(value);
            const inicio = cell.getRow().getData().INICIO;
            return Number.isInteger(n) && n >= inicio;
          },
          accessorDownload: (val) => val,
        },
      ],
      staticColumns: [
        {
          title: "Kc",
          field: "KC",
          minWidth: 90,
          width: 90,
          tooltip_text: "É o KC da planta",
          tooltip: (cell) => cell._cell.column.definition.tooltip_text,
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value >= 0) || value === "",
        },
        {
          title: "Estresse",
          field: "STRESS",
          editor: "select",
          minWidth: 130,
          maxWidth: 130,
          accessorDownload: this.booleanFormatter,
          tooltip_text: "É o estresse da planta",
          headerTooltip: (header) => header._column.definition.tooltip_text,
          tooltip: (cell) => cell._cell.column.definition.tooltip_text,
          formatter: (cell) => this.booleanFormatter(cell.getValue()),
          editorParams: {
            values: [0, 1],
            listItemFormatter: function (value, title) {
              return title ? "Sim" : "Não";
            },
          },
        },
        {
          title: "Projeção de Rama (m)",
          field: "BRANCH",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
          },
        },
        {
          title: "Profundidade de Raiz (cm)",
          field: "DEPTH_ROOT",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
          },
        },
        {
          title: "Fator de Disponibilidade Crítica",
          field: "AVAILABILITY",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          validator: (cell, value) => (value && value > 0) || value === "",
          editorParams: {
            min: 0,
            max: 1,
          },
        },
      ],
    };
  },
  mounted() {
    this.loadFarmsDap();
    // Recalcula o layout do Tabulator quando o modal termina de abrir: a largura só estabiliza aí,
    // senão o fitColumns deixa um scroll horizontal fantasma quando o modal não tem barra vertical.
    this.$root.$on("bv::modal::shown", this.redrawTable);
    window.onclick = (event) => {
      if (
        event.target.id != "collapse-downloads" &&
        event.target.id != "downloads-options" &&
        this.showDownloadOptions
      ) {
        this.showDownloadOptions = false;
      }
    };
  },
  beforeDestroy() {
    this.$root.$off("bv::modal::shown", this.redrawTable);
  },
  computed: {
    changedTableData() {
      const hasLengthChanged =
        this.tableDataUnchanged.length !== this.tableData.length;

      const currentTableValues = this.tableData
        .map((row) => {
          return Object.values(row);
        })
        .flat();

      const startTableValues = this.tableDataUnchanged
        .map((row) => {
          return Object.values(row);
        })
        .flat();

      const hasUpdatedAnyColumn = currentTableValues.findIndex((val, index) => {
        return Number(val) !== Number(startTableValues[index]);
      });

      return hasLengthChanged || hasUpdatedAnyColumn >= 0;
    },
    lastRowItem() {
      return this.tableData[this.tableData.length - 1];
    },
    hasUncompletedRow() {
      return this.tableData.find((item) => this.hasNullAttribute(item));
    },
  },

  watch: {
    loading: {
      handler(newValue) {
        if (newValue) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
        }
      },
    },
    tableData: {
      handler(newValue) {
        // Re-deriva Início (contíguo) e clampa Fim; só reatribui se mudou (evita loop com reactiveData).
        const normalized = this.normalizeRanges(newValue);
        if (JSON.stringify(normalized) !== JSON.stringify(newValue)) {
          this.updateTableData(normalized);
        }
      },
      deep: true,
    },
  },

  methods: {
    redrawTable() {
      this.$nextTick(() => {
        const dt = this.$refs.dataTable;
        if (dt && dt.tabulator) dt.tabulator.redraw(true);
      });
    },
    async saveTable() {
      if (this.hasUncompletedRow) {
        this.alertUncompletedRow();

        return false;
      } else {
        // submit() salva a curva e recalcula atomicamente no backend; só marca "sem alterações"
        // se ele não lançar (curva persistida). Ver §6 do doc de manejo.
        if (!(await this.submit())) return false;

        this.tableDataUnchanged = JSON.parse(JSON.stringify(this.tableData));
        return true;
      }
    },
    async saveTableAndCloseModal() {
      if (!(await this.saveTable())) {
        return;
      }

      this.emitSavedTable();
    },
    emitSavedTable() {
      this.$emit("table-saved", true);
    },
    closeItemsWithSectorsModal() {
      this.$refs.farmsHasSectorModal.hide();
    },
    closeEmptyFarmModal() {
      this.$refs.notSaveEmptyFarmModal.hide();
    },
    alertUncompletedRow() {
      alert("Termine de preencher a linha incompleta!");
    },
    replyRows(between = null) {
      if (!between && !this.hasUncompletedRow) {
        const clones = this.itemsSelected
          .sort((a, b) => a.INICIO - b.INICIO)
          .map((item) => ({ ...item }));
        this.tableData = this.normalizeRanges([...this.tableData, ...clones]);
      } else if (this.hasUncompletedRow) {
        this.alertUncompletedRow();
      }
    },
    updateSelectedItems(selectedItems) {
      this.itemsSelected = selectedItems;
    },
    // Colapsa só quando TODOS os campos são iguais (inclusive STRESS) e os dias são contíguos.
    rangeFieldsEqual(a, b) {
      return ["KC", "STRESS", "BRANCH", "DEPTH_ROOT", "AVAILABILITY"].every(
        (f) => String(a[f]) === String(b[f])
      );
    },
    // Linhas por-dia (DAP) -> faixas (INICIO/FIM). Usado na carga.
    collapseToRanges(rows) {
      const sorted = [...rows].sort((a, b) => a.DAP - b.DAP);
      const ranges = [];
      for (const row of sorted) {
        const last = ranges[ranges.length - 1];
        if (last && this.rangeFieldsEqual(last, row) && row.DAP === last.FIM + 1) {
          last.FIM = row.DAP;
        } else {
          ranges.push({
            INICIO: row.DAP,
            FIM: row.DAP,
            KC: row.KC,
            STRESS: row.STRESS,
            BRANCH: row.BRANCH,
            DEPTH_ROOT: row.DEPTH_ROOT,
            AVAILABILITY: row.AVAILABILITY,
          });
        }
      }
      return ranges;
    },
    // Faixas (INICIO/FIM) -> linhas por-dia (DAP contíguo). Usado no save.
    expandToDays(ranges) {
      const rows = [];
      for (const r of ranges) {
        for (let dap = r.INICIO; dap <= r.FIM; dap++) {
          rows.push({
            DAP: dap,
            KC: r.KC,
            STRESS: r.STRESS,
            BRANCH: r.BRANCH,
            DEPTH_ROOT: r.DEPTH_ROOT,
            AVAILABILITY: r.AVAILABILITY,
          });
        }
      }
      return rows;
    },
    // Re-deriva INICIO contíguo preservando o SPAN (nº de dias) de cada faixa: arrastar/reordenar
    // move o bloco todo, só deslocando início/fim. Faixa nova/incompleta = 1 dia.
    normalizeRanges(rows) {
      let start = 0;
      return rows.map((r) => {
        const inicio = start;
        const inicioRaw = Number(r.INICIO);
        const fimRaw = Number(r.FIM);
        const span =
          Number.isFinite(inicioRaw) && Number.isFinite(fimRaw) && fimRaw >= inicioRaw
            ? fimRaw - inicioRaw + 1
            : 1;
        const fim = inicio + span - 1;
        start = fim + 1;
        return {
          INICIO: inicio,
          FIM: fim,
          KC: r.KC,
          STRESS: r.STRESS,
          BRANCH: r.BRANCH,
          DEPTH_ROOT: r.DEPTH_ROOT,
          AVAILABILITY: r.AVAILABILITY,
        };
      });
    },
    updateTableData(tableData) {
      this.tableData = tableData;
    },
    hasNullAttribute(obj) {
      return !!Object.values(obj).filter((att) => att === null || att === "")
        .length;
    },
    addRowDap() {
      if (!this.hasUncompletedRow) {
        this.tableData = this.normalizeRanges([
          ...this.tableData,
          {
            INICIO: null,
            FIM: null,
            KC: null,
            STRESS: null,
            BRANCH: null,
            DEPTH_ROOT: null,
            AVAILABILITY: null,
          },
        ]);
      } else {
        this.alertUncompletedRow();
      }
    },
    deleteRowBtn() {
      const toRemove = new Set(this.itemsSelected.map((el) => el.INICIO));
      this.tableData = this.normalizeRanges(
        this.tableData.filter((data) => !toRemove.has(data.INICIO))
      );
      this.itemsSelected = [];
    },
    loadFarmsDap() {
      showFarmsDapByIdFarmUseCase
        .execute(this.idFarm)
        .then((resp) => {
          this.tableData = this.collapseToRanges(resp[0] || []);
          this.tableDataUnchanged = JSON.parse(JSON.stringify(this.tableData));
        })
        .catch(console.error);
    },
    // Salva a curva de KC e recalcula os setores associados numa ÚNICA requisição atômica no backend
    // (delete + insert + recalc na mesma transação/fluxo). Antes eram POST /sql soltos: um erro no
    // insert após o delete deixava a curva vazia (ver §6 do doc de manejo). Retorna true em sucesso.
    async submit() {
      if (!this.idFarm) return false;

      const rows = this.expandToDays(this.tableData);

      try {
        this.loading = true;
        this.currentLoadingMessage =
          "Salvando cultivar e recalculando setores...";

        await management.saveFarmDap({
          idFarm: this.idFarm,
          rows,
          fkEditor: cookies.get("ID"),
        });

        this.loading = false;
        alert("Tabela salva com sucesso", "s");
        return true;
      } catch (e) {
        this.loading = false;
        alert("Erro ao salvar cultivar", "e");
        console.error(e);
        return false;
      }
    },
  },
};
</script>
<style scoped>

.download-options {
  position: absolute;
  background: white;
  padding: 5px;
  right: 0;
  z-index: 99;
  min-width: 10em;
  max-width: 15em;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 4px;
}
.last-update-farm {
  margin-right: 0;
  text-align: right;
  font-size: 0.72em;
  color: var(--text-gray-primary);
}
</style>
